<template>
  <div class="relation-main">
    <n-text
      :type="item.isFailed ? 'error' : item.isDangling ? 'warning' : 'default'"
      :title="item.diagnosticMessage"
    >
      {{ label }}{{ item.isSuppressed ? '（抑制）' : '' }}{{ item.isFailed ? '（失败）' : item.isDangling ? '（悬空）' : '' }}
    </n-text>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from 'vue';
import {NText} from 'naive-ui';
import type {SketchRelationSnapshot} from '@puppycad/cad-core';

defineProps({
  /** 当前关系诊断快照。 */
  item: {
    type: Object as PropType<SketchRelationSnapshot>,
    required: true,
  },
  /** 调用方按实体上下文解析后的关系名称。 */
  label: {
    type: String,
    required: true,
  },
});
</script>
